import { useApiMiddleware } from "./useApiMiddleware";
import { UNSPLASH_ACCESS_KEY } from "../config/key";

export const useUnsplashImages = (query, color) => new Promise((resolve, reject) => {

    const url = `https://api.unsplash.com/search/photos?page=1&query=${query}&client_id=${UNSPLASH_ACCESS_KEY}&per_page=50&color=${color}&orientation=landscape`;

    fetch(url, {
        method: 'GET'
    })
        .then((res) => (res.json()))
        .then(async(response) => {
            const resultValue = await useApiMiddleware(response) 

            if(Array.isArray(resultValue?.results))
            {
                resolve(resultValue.results)
            }

        })

})